<style scoped>
.horizontal-split {
	display: flex;
	flex-direction: column;
	height: 100vh;
	overflow: hidden;
}

.split-top {
	flex: 0 0 50%;
	position: relative;
	overflow: hidden;
	border-bottom: 2px solid #dee2e6;
}

.split-bottom {
	flex: 1;
	overflow-y: auto;
}
</style>
<template>
	<div class="horizontal-split">
		<div class="split-top">
			<slot name="top"></slot>
		</div>
		<div class="split-bottom">
			<slot name="bottom"></slot>
		</div>
	</div>
</template>
